import Box from "@mui/material/Box";
import React from "react";

const SeparatorDSFR = () => {
  return <Box sx={{ height: { xs: 0, lg: 16 } }} />;
};

export default SeparatorDSFR;
